/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ cm1: NonNullable<unknown>, cm2: NonNullable<unknown> }} Inconsistent_CommutatorInputs */



/**
* | output |
* | --- |
* | "Left: {cm1} Right: {cm2}" |
*
* @param {Inconsistent_CommutatorInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const inconsistent_commutator = /** @type {((inputs: Inconsistent_CommutatorInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inconsistent_CommutatorInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Left: ${i?.cm1}   Right: ${i?.cm2}`)
	return /** @type {LocalizedString} */ (`Gauche : ${i?.cm1}   Droit : ${i?.cm2}`)
});